import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ChangePasswordPage } from '@/pages/change-password';
import { requireAuth } from '../require-auth';

/**
 * «Изменить пароль» — the signed-in merchant's own password.
 *
 * The route file is `profile_.change-password.tsx`; the trailing `_` is
 * TanStack Router's opt-out from nesting. Without it the router treats
 * `/profile/change-password` as a CHILD of `/profile`, whose component has no
 * `<Outlet />`, so the screen would render blank inside the profile page —
 * exactly the trap `profile_.users.tsx` documents.
 *
 * Behind `requireAuth`, unlike the public `/reset-password`: changing a KNOWN
 * password requires the session it belongs to, and the old password is what
 * proves ownership rather than an SMS code.
 */
export const Route = createFileRoute('/profile_/change-password')({
  // Auth guard — see `require-auth.ts`. Runs before the component mounts.
  beforeLoad: requireAuth,
  component: ChangePasswordRoute,
});

/**
 * On success it returns to `/profile` rather than to `/login`: the endpoint
 * issues no new tokens and revokes nothing, so the session that made the
 * request is still valid and there is nothing to sign back in to.
 */
function ChangePasswordRoute() {
  const navigate = useNavigate();

  return <ChangePasswordPage onCompleted={() => void navigate({ to: '/profile' })} />;
}
